<template>
    <client-page class="wrap--mypage">
        <v-container>
            <div class="mypage-container">
                <!-- 네비게이션 메뉴 -->
                <mypage-navigation />
                <!-- 페이지 콘텐츠 -->
                <div class="mypage-contents">
                    <div class="tit-wrap mb-12 mb-md-16">
                        <h2 class="tit">{{ title }}</h2>
                    </div>

                    <div class="tab-wrap">
                        <v-tabs hide-slider class="tab tab--block">
                            <v-tab v-for="{ value, text } in auctionHalls" :key="value" :to="`/mypage/bids-${type}/${value}`">{{ text }}</v-tab>
                        </v-tabs>
                        <v-divider class="primary border-3"></v-divider>
                    </div>

                    <v-tabs-items :value="tab">
                        <bids-list v-for="{ value } in auctionHalls" :key="value" :hall="value" />
                    </v-tabs-items>
                </div>
            </div>
        </v-container>
    </client-page>
</template>

<script>
import BidsList from "@/components/client/mypage/bids-list.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";

import { AUCTION_PROGRAM_HALLS } from "@/assets/variables";
const auctionHalls = Object.values(AUCTION_PROGRAM_HALLS);

export default {
    components: {
        BidsList,
        ClientPage,
        MypageNavigation,
    },

    props: {
        tab: { type: String, default: AUCTION_PROGRAM_HALLS.AUCTION_A.value },
        type: { type: String, default: "all" },
    },
    data: () => ({ auctionHalls }),
    computed: {
        accessToken() {
            return this.$store.state.accessToken;
        },
        phone() {
            return this.phone1 && this.phone2 && this.phone3 ? [this.phone1, this.phone2, this.phone3].join("-") : undefined;
        },
        payload() {
            return this.$store.state.payload || {};
        },
        scope() {
            return this.payload.scope || [];
        },
        title() {
            if (this.type == "won") return "낙찰내역";
            if (this.type == "all") return "응찰내역";
            return "응찰내역";
        },
    },

    mounted() {
        this.init();
    },
    watch: {
        tab() {
            this.init();
        },
        "$route.params.tab"() {
            if (this.$route.params.tab !== this.tab) this.init();
        },
        "$route.params.type"() {
            if (this.$route.params.type !== this.type) this.init();
        },
    },
    methods: {
        async init() {
            try {
                if (!this.accessToken) {
                    this.$router.push({
                        path: "/login",
                        params: this.$router.params,
                    });
                }
                this.syncRoute();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },
        syncRoute() {
            const path = `/mypage/bids-${this.type}/${this.tab}`;
            if (this.$route.path !== path) this.$router.replace(path);
        },
    },
};
</script>
